"use strict";
(function (global) {


  /**
   * Получает наименование записей справочников по ссылке.
   *
   * @function getReferenceRecordsNames
   * @param {Array} ids Список ИД записей справочников.
   * @return {Deferred<Object>} Наименование записей справочников.
   * @see https://api.jquery.com/category/deferred-object/
   */
  global.reference.getReferenceRecordsNames = function (ids) {
    var d = $.Deferred();

    WA.SRV.call('/api/LinkQuery.asmx/GetReferenceRecordsById', {
      ids: ids
    }).done(function (data) {
      var jsonObject = JSON.parse(data);
      // Преобразуем в ассоциативный массив
      var names = {};
      jsonObject.forEach(function (item, index) {
        var link = new WA.Link(item.id, OBJECT_TYPE.REFERENCE_RECORD, item.compcode);
        link['name'] = item.name;
        names[item.id] = link;
      });
      d.resolve(names);
    }).fail(function (err) {
      d.reject(err);
    });

    return d.promise();
  };

  /**
   * Удаляет запись справочника.
   *
   * @function WebAccess.services.reference.deleteRecord
   * @param {string} referenceCode Код справочника
   * @param {integer} recordID Идентификатор записи справочника
   * @return {Deferred} Deferred-объект для управления отложенными вызовами.
   * @example
   *
   * WA.SRV.reference.deleteRecord("РАБ",123123).done(
   *  alert('Запись с id 123123 удалена');
   * );
   */
  global.reference.deleteRecord = function (referenceCode, recordID) {
    return global.call("/Reference.asmx/DeleteRecord",
      {
        "ReferenceCode": referenceCode,
        "RecordID": recordID
      },
      L('REF_REC_DELETING'),
      L('REF_REC_DELETE_COMPLETE')).fail(function () {
        WebAccess.components.notifications.Toast.hideAll();
      });
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
   * Включает автоподбор ширины колонок.
   *
   * @function WebAccess.services.reference.columnsAutoWidthEnabled
   * @param {string} referenceCode Код справочника
   * @param {string} referenceView Представление справочника
   * @param {boolean} isEnabled Если параметр имеет значение true, автоподбор ширины колонок будет включен, иначе false
   * @return {Deferred} Deferred-объект для управления отложенными вызовами.
   */
  global.reference.columnsAutoWidthEnabled = function (referenceCode, referenceView, isEnabled, opt_placementContext) {
    return global.call("/Reference.asmx/ColumnsAutoWidthEnabled", {
      "ReferenceCode": referenceCode,
      "ReferenceView": referenceView,
      "PlacementContext": opt_placementContext || "",
      "Enabled": isEnabled
    });
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
   * Устанавливает фильтр для справочника.
   *
   * @function WebAccess.services.reference.setFilter
   * @param  {string} referenceCode Код справочника
   * @param  {integer} filterID Идентификатор фильтра
   * @return {Deferred} Deferred-объект для управления отложенными вызовами.
   */
  global.reference.setFilter = function (referenceCode, filterID, opt_referenceView, opt_placementContext) {
    return global.call("/Reference.asmx/SetFilter", {
      "ReferenceCode": referenceCode,
      "ReferenceView": opt_referenceView || "",
      "PlacementContext": opt_placementContext || "",
      "FilterID": filterID
    });
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
   * Создает новый фильтр для справочника.
   * В процессе создания нового фильтра копируются значения фильтрации из автофильтра или из текущего выбранного фильтра.
   *
   * @function WebAccess.services.reference.createNewFilter
   * @param  {string} referenceCode Код справочника
   * @param  {integer} filterName Имя нового фильтра
   * @return {Deferred} Deferred-объект для управления отложенными вызовами.
   */
  global.reference.createNewFilter = function (referenceCode, filterName, opt_referenceView, opt_placementContext) {
    return global.call("/Reference.asmx/CreateNewFilter", {
      "ReferenceCode": referenceCode,
      "ReferenceView": opt_referenceView || "",
      "PlacementContext": opt_placementContext || "",
      "Name": filterName
    });
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
   * Сохраняет фильтр справочника.
   * Веб-сервис изменяет фильтр, идентификатор которого был передан.
   * В изменяемый фильтр копируются значения текущего фильтра из базы данных, по умолчанию – автофильтра.
   *
   * @function WebAccess.services.reference.saveFilter
   * @param  {string} referenceCode Код справочника
   * @param  {integer} filterID Идентификатор сохраняемого фильтра
   * @param  {string} filterName Новое имя фильтра
   * @return {Deferred} Deferred-объект для управления отложенными вызовами.
   */
  global.reference.saveFilter = function (referenceCode, filterID, opt_filterName, opt_referenceView, opt_placementContext) {
    return global.call("/Reference.asmx/SaveFilter", {
      "ReferenceCode": referenceCode,
      "ReferenceView": opt_referenceView || "",
      "PlacementContext": opt_placementContext || "",
      "FilterID": filterID,
      "FilterName": opt_filterName || ""
    });
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
   * Удаляет фильтр справочника.
   *
   * @function WebAccess.services.reference.removeFilter
   * @param  {string} referenceCode Код справочника
   * @param  {integer} filterID Идентификатор удаляемого фильтра
   * @return {Deferred} Deferred-объект для управления отложенными вызовами.
   */
  global.reference.removeFilter = function (referenceCode, filterID, opt_referenceView, opt_placementContext) {
    return global.call("/Reference.asmx/RemoveFilter", {
      "ReferenceCode": referenceCode,
      "ReferenceView": opt_referenceView || "",
      "PlacementContext": opt_placementContext || "",
      "FilterID": filterID
    });
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
   * Получает название справочника.
   *
   * @function WebAccess.services.reference.getReferenceCaption
   * @param  {string} referenceCode Код справочника
   * @return {Deferred} Deferred-объект для управления отложенными вызовами.
   */
  global.reference.getReferenceCaption = function (referenceCode) {
    return global.call("/Reference.asmx/GetReferenceCaption", {
      "ReferenceCode": referenceCode
    });
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

})(window.WebAccess.services);
